import { Box, DialogContent, Typography } from '@mui/material';
import { StyledDialog } from 'theme/index';

interface FinishingUpOverlayProps {
  open: boolean;
}

const FinishingUpOverlay = ({ open }: FinishingUpOverlayProps) => {
  return (
    <StyledDialog open={open} maxWidth='sm' fullWidth aria-describedby='finishing-up-overlay'>
      <DialogContent sx={{ pt: 4, px: 3 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Box
            component='img'
            src='/images/appointmentConfirmed.png'
            alt='Great Work'
            sx={{
              width: { xs: 125, sm: 125 },
              height: 'auto',
              objectFit: 'contain',
              mb: 2,
            }}
          />

          <Typography variant='h1' gutterBottom>
            Great Work!
          </Typography>

          <Typography variant='body1' gutterBottom>
            Thank you for completing your Policies & Consents. We’re preparing your completed documents. You’ll be
            able to continue once they’re ready.
          </Typography>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

export default FinishingUpOverlay;
